export default __webpack_public_path__ + "static/media/next_icon.cc2f1ae9.png";